<template>
  <BliModal
    :active="showModal"
    :width="'small'"
  >
    <BliModalHeader @close="onCancelNpsFeedback">
      <template #title>
        {{ $t('npsFeedback.heading') }}
      </template>
    </BliModalHeader>
    <section class="blue-section">
      <BliIconSiReviewRating class="icon" />
      <div class="title">
        {{ $t('npsFeedback.title') }}
      </div>
    </section>
    <section class="nps-body">
      <section class="nps-container">
        <section class="rating-section">
          <div class="text">
            {{ ratingText }}
          </div>
          <BliRating
            v-model="rating"
            size="large"
            class="rating-star"
          />
        </section>
        <BliField
          size="small"
          @paste="handlePaste"
        >
          <BliTextArea
            v-model="comments"
            maxlength="1000"
            :placeholder="$t('npsFeedback.comment.placeholder')"
            :min-height="102"
            :min-width="328"
            resizable="none"
            @keydown="dontAllowCertainSpecialCharacters"
          />
          <template #help-text>
            {{ $t('npsFeedback.comment.helperText') }}
          </template>
        </BliField>
      </section>
    </section>
    <BliModalFooter>
      <BliButton
        prominence="primary"
        color="common"
        :loading="isLoading"
        :disabled="!rating"
        @click="onSaveNpsFeedback"
      >
        {{ $t('npsFeedback.send') }}
      </BliButton>
    </BliModalFooter>
  </BliModal>
</template>
<script src="./index.js" />
<style lang="scss" scoped>
@import "@vue3/assets/styles/_responsive.scss";
    html:not([dark]) {
      @import '@blibli/blue-design-tokens/dist/tokens-default.scss';
      @import './index.scss';
    }
    html[dark] {
      @import '@blibli/blue-design-tokens/dist/tokens-dark.scss';
      @import './index.scss';
    }
    @import '@blibli/blue-design-tokens/dist/tokens-default.scss';
</style>
